"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Flex = _interopRequireDefault(require("../../../../../components/shared-components/Flex"));

var _CustomStatistic = _interopRequireDefault(require("../../../../../components/shared-components/CustomStatistic"));

var DataDisplayWidget = function DataDisplayWidget(props) {
  var size = props.size,
      value = props.value,
      title = props.title,
      icon = props.icon,
      color = props.color,
      avatarSize = props.avatarSize,
      vertical = props.vertical,
      style = props.style;
  var customStatisticProps = {
    size: size,
    value: value,
    title: title
  };
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Flex.default, {
    alignItems: "center",
    flexDirection: vertical ? 'column' : 'row'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Avatar, {
    size: avatarSize,
    shape: "square",
    icon: icon,
    className: "ant-avatar-".concat(color)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: vertical ? 'mt-1 text-center' : 'ml-3'
  }, /*#__PURE__*/_react.default.createElement(_CustomStatistic.default, customStatisticProps))));
};

DataDisplayWidget.defaultProps = {
  avatarSize: 20,
  vertical: false,
  style: 200
};
var _default = DataDisplayWidget;
exports.default = _default;